export const ActionTypes = {
  FETCH_UNASSIGNED_JOBS_OPERATION: 'services/unassignedJobsOperation/fetch_unassigned_jobs_operation',
  SET_UNASSIGNED_JOBS_OPERATION: 'services/unassignedJobsOperation/set_unassigned_jobs_operation',
  SET_UNASSIGNED_JOBS_OPERATION_LOADER_STATUS:
    'services/unassignedJobsOperation/set_unassigned_jobs_operation_loader_status',
  ADD_UPDATE_UNASSIGNED_JOBS_OPERATION: 'services/unassignedJobsOperation/add_update_unassigned_jobs_operation',
  DELETE_UNASSIGNED_JOBS_OPERATION: 'services/unassignedJobsOperation/delete_unassigned_jobs_operation',
};

const fetchUnassignedJobOperations = () => ({
  type: ActionTypes.FETCH_UNASSIGNED_JOBS_OPERATION,
});

const setUnassignedJobOperations = ({ unassignedJobsOperationData }) => ({
  unassignedJobsOperationData,
  type: ActionTypes.SET_UNASSIGNED_JOBS_OPERATION,
});

const setUnassignedJobOperationsLoaderStatus = ({ unassignedJobOperationsLoader }) => ({
  unassignedJobOperationsLoader,
  type: ActionTypes.SET_UNASSIGNED_JOBS_OPERATION_LOADER_STATUS,
});

const addUpdateUnassignedJobOperation = ({ actionName, unassignedJobOperationObj }) => ({
  actionName,
  unassignedJobOperationObj,
  type: ActionTypes.ADD_UPDATE_UNASSIGNED_JOBS_OPERATION,
});

const deleteUnassignedJobOperation = ({ unassignedJobId }) => ({
  unassignedJobId,
  type: ActionTypes.DELETE_UNASSIGNED_JOBS_OPERATION,
});

export default {
  fetchUnassignedJobOperations,
  setUnassignedJobOperations,
  setUnassignedJobOperationsLoaderStatus,
  addUpdateUnassignedJobOperation,
  deleteUnassignedJobOperation,
};
